<ng-container *ngIf="config && config.items">
    
        
        <table class="xsPanelItems">
            <!-- <tr><th colspan="3"> <xs-debug label="items" [item]="config"></xs-debug> </th></tr> -->
            <tr>
                <td *ngIf="left" class="left">
                    <ng-container *ngFor="let item of left">
                        [{{ item.id }}]
                    </ng-container>
                </td>
                <td *ngIf="center" class="center">c
                    <ng-container *ngFor="let item of center">
                        [{{ item.id }}]
                    </ng-container>
                </td>
                <td *ngIf="right" class="right">r
                    <ng-container *ngFor="let item of right">
                        [{{ item.id }}]
                    </ng-container>
                </td>
            </tr>
        </table>
    </ng-container>